import React, { memo, useCallback } from 'react'

import {
  Button,
  Check,
  Icon,
  classnames,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func, string } from 'prop-types'

import { iconSize } from 'Pods/ThreeDStudio/constants'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'
import { selectExportFormat, triggerExport } from 'Pods/ThreeDStudio/Store/actions/export'

import { EXPORT_FORMAT_LABELS, EXPORT_FORMAT_ORDER } from '../formatLabels'

const checkIcon = (
  <span className="export-format-popover__check">
    <Icon svgComponent={Check} color="dark" size={iconSize} notSpaced />
  </span>
)

function ExportFormatPopover({ selectedFormat, onClosePopover }) {
  const assetId = useThreeDStudioStore(state => state.viewer.inputThreeD)

  const handleSelect = useCallback((format) => {
    selectExportFormat(format)
    triggerExport(assetId, format)
    onClosePopover()
  }, [assetId, onClosePopover])

  return (
    <ul className="export-format-popover">
      {EXPORT_FORMAT_ORDER.map((format) => {
        const isSelected = format === selectedFormat
        return (
          <li
            key={format}
            className={classnames(
              'export-format-popover__row',
              isSelected && 'export-format-popover__row--selected',
            )}
          >
            <Button
              type="ghost"
              size="small"
              variant="with-icon"
              actionType="button"
              customClass="export-format-popover__option cgt-body-base-semibold"
              trailIcon={isSelected ? checkIcon : null}
              onClick={() => handleSelect(format)}
            >
              {EXPORT_FORMAT_LABELS[format]}
            </Button>
          </li>
        )
      })}
    </ul>
  )
}

ExportFormatPopover.propTypes = {
  selectedFormat: string.isRequired,
  onClosePopover: func.isRequired,
}

export default memo(ExportFormatPopover)
